module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17.481' height='10.784' viewBox='0 0 17.481 10.784'%3E %3Cdefs%3E %3Cstyle%3E .cls-1 %7B fill: %23f77629; %7D %3C/style%3E %3C/defs%3E %3Cpath id='Op_component_1' data-name='Op component 1' class='cls-1' d='M1360.079,1155.724l-1.92,1.469-6.808-6.842-7.01,7.214-1.743-1.872,8.723-8.912Z' transform='translate(-1342.598 -1146.782)'/%3E %3C/svg%3E"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow_up.svg
// module id = 942
// module chunks = 0